require("!!D:\\cockpit\\node_modules\\script-loader\\addScript.js")(require("!!D:\\cockpit\\node_modules\\raw-loader\\index.js!D:\\cockpit\\node_modules\\source-map-loader\\index.js!D:\\cockpit\\src\\assets\\js\\modernizr.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/assets/js/modernizr.min.js
// module id = 225
// module chunks = 3